import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Grid } from '@mui/material'
import Box from '@mui/material/Box'

import OrderAPI from '../../../../../../api/orbitV1/OrderAPI'
import BreadcrumbsMUI from '../../../../../../common/AbstractBreadcrumbs/BreadcrumbsMUI'
import PageLayout from '../../../../../../common/Layout/Page/PageLayout'
import { ColorBoxContent } from '../../../../../../common/ui/colorBox'
import { OrderChangeState } from '../../../../../../types/order.type'
import SelectedOrderHeader from '../../components/SelectedOrderHeader'

import UploadSims from './components/UploadSims'

function ManualProvisionOrderPage() {
  const { orderId } = useParams()

  /**
   * Fetch from backend and store into state.
   * @type {[import('../../../../../../types/order.type').OrderModel | null, *]}
   */
  const [order, setOrder] = useState(null)

  useEffect(() => {
    async function getOrder() {
      try {
        const orderStatus = await OrderAPI.getOrderStatus(orderId)
        if (orderStatus) setOrder(orderStatus.data)
      } catch (error) {
        toast.error(error.response.message)
      }
    }

    getOrder()
  }, [orderId])

  if (!order) {
    return <div>Loading</div>
  } else if (order && order.status !== OrderChangeState.PAYMENT_RECEIVED) {
    return <div>Order {orderId} cannot be manually provisioned</div>
  } else {
    return (
      <PageLayout header='Manual Provision'>
        <Grid container direction='column' spacing={2}>
          <Grid item>
            <ColorBoxContent variant='white'>
              <BreadcrumbsMUI
                crumbs={[
                  {
                    route: '/hq/manage-orders',
                    name: 'Manage Orders'
                  },
                  {
                    route: `/hq/manage-orders/${order.orderNo}`,
                    name: `Manage ${order.orderNo}`
                  },
                  {
                    route: `/hq/manage-orders/${order.orderNo}/manual-provision`,
                    name: 'Manual Provision'
                  }
                ]}
              />
            </ColorBoxContent>
          </Grid>
          <Grid item>
            <ColorBoxContent style={{ marginTop: '1rem' }}>
              <SelectedOrderHeader order={order} />
            </ColorBoxContent>
            <Box sx={{ marginTop: '12px', marginLeft: '24px' }}>
              <UploadSims orderNo={order.orderNo} />
            </Box>
          </Grid>
        </Grid>
      </PageLayout>
    )
  }
}

export default ManualProvisionOrderPage
